module.exports = __webpack_public_path__ + "static/media/green_back.80d296e9.png";